const initialState = { posClientsData: [], posClientData: [], filteredData: [], edited: false, modified: false, posClientID: null };

export const POSCLIENTREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_POS_CLIENTS':
            return {
                ...state,
                posClientsData: action.data,
                posClientData: state.posClientData
            }
        case 'GET_POS_CLIENT':
            return {
                ...state,
                posClientsData: state.posClientsData,
                posClientData: action.data
            }
        case 'FILTER_POS_CLIENTS':
            return {
                ...state,
                posClientsData: state.posClientsData,
                filteredData: action.data
            }
        case 'SET_EDIT':
            return {
                ...state,
                edited: action.data
            }
        case 'SET_MODIFIED':
            return {
                ...state,
                modified: action.data
            }
        case 'SET_POS_CLIENTID':
            return {
                ...state,
                posClientID: action.data
            }

        default:
            return state;
    }
}